export default __webpack_public_path__ + "static/media/khabyBro.9169c4d8.jpg";